import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18b71ca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "arrow",
  "data-popper-arrow": ""
}, null, -1))

import {
  ref, toRefs, watch, watchEffect,
} from 'vue';
import { createPopper, Instance, Placement } from '@popperjs/core';
import { onClickOutside, onKeyStroke } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  props: {
    menuClass: null,
    placement: { default: 'bottom-start' },
    offset: { type: [Array, Function], default: () => [0, 6] }
  },
  setup(__props: any) {

const props = __props as { menuClass?: string, placement: string, offset: number[] |(() => number[]) }



const { menuClass, placement, offset } = toRefs(props);
const opened = ref(false);
const open = () => { opened.value = true; };
const close = () => { opened.value = false; };
const toggle = () => { opened.value = !opened.value; };

const dropdown = ref<HTMLElement | null>(null);
const trigger = ref<HTMLElement | null>(null);
const menu = ref<HTMLElement | null>(null);
const popperInstance = ref<Instance | null>(null);
const setPopperEventListeners = (enabled: boolean) => {
  popperInstance.value?.setOptions((options) => ({
    ...options,
    modifiers: [
      ...(options.modifiers ?? []),
      { name: 'eventListeners', enabled },
    ],
  }));
};

watchEffect(() => {
  if (popperInstance.value || !trigger.value || !menu.value) return;
  popperInstance.value = createPopper(trigger.value, menu.value, {
    placement: placement.value as Placement,
    modifiers: [
      { name: 'preventOverflow', options: { padding: 16 } },
      { name: 'offset', options: { offset: offset.value } },
    ],
  });
});
watch(opened, (isOpened) => {
  setPopperEventListeners(isOpened);
  if (isOpened) popperInstance.value?.update();
});

onClickOutside(dropdown, close);
onKeyStroke('Escape', close);

const hoverListeners = {
  mouseenter: open,
  mouseleave: close,
  focus: open,
  blur: close,
};

const toggleListeners = {
  click: (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    toggle();
  },
  'keypress.enter': toggle,
};

const scope = {
  opened, open, close, toggle, hoverListeners, toggleListeners,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative",
    ref_key: "dropdown",
    ref: dropdown
  }, [
    _createElementVNode("div", {
      ref_key: "trigger",
      ref: trigger
    }, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(scope)))
    ], 512),
    _withDirectives(_createElementVNode("div", {
      ref_key: "menu",
      ref: menu,
      id: "menu",
      class: _normalizeClass(["z-30 bg-white rounded-lg border border-gray-300 shadow-lg shadow-purple-500/10", _unref(menuClass)])
    }, [
      _renderSlot(_ctx.$slots, "menu", _normalizeProps(_guardReactiveProps(scope))),
      _hoisted_1
    ], 2), [
      [_vShow, opened.value]
    ])
  ], 512))
}
}

})